var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 599.53 527.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-29,.cls-31,.cls-8{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-3{clip-path:url(#clip-path);}.cls-11,.cls-4,.cls-43{fill:#0f1048;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#6c6cff;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{stroke:#fff;}.cls-10,.cls-29,.cls-31,.cls-43,.cls-8{stroke-miterlimit:10;}.cls-10,.cls-8{stroke-width:3px;}.cls-36,.cls-39,.cls-9{fill:#fff;}.cls-10,.cls-31{stroke:#6c6cff;}.cls-11{opacity:0.7;}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:#fdbc9d;}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:#e5f4ff;}.cls-20{fill:url(#linear-gradient-8);}.cls-21{fill:url(#linear-gradient-9);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:#d86964;opacity:0.5;}.cls-27{fill:url(#linear-gradient-14);}.cls-28{fill:url(#linear-gradient-15);}.cls-29,.cls-31{stroke-width:6.77px;}.cls-29{stroke:url(#linear-gradient-16);}.cls-30{fill:#fc0;}.cls-32{fill:url(#linear-gradient-17);}.cls-33{fill:url(#linear-gradient-18);}.cls-34{fill:url(#linear-gradient-19);}.cls-35{fill:url(#linear-gradient-20);}.cls-36{opacity:0.2;}.cls-37{fill:url(#radial-gradient);}.cls-38{fill:url(#radial-gradient-2);}.cls-39{opacity:0.3;}.cls-40{fill:url(#linear-gradient-21);}.cls-41{fill:url(#linear-gradient-22);}.cls-42{fill:url(#linear-gradient-23);}.cls-43{stroke:#e5f4ff;stroke-linecap:round;stroke-width:5.78px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 105.53,
    y1: 399.65,
    x2: 497.53,
    y2: 399.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6c6cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#19194f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6c6cff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 301.53,
    cy: 417.65,
    rx: 196,
    ry: 34.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.53,399.65c0-19.06-98.75-139.5-207-139.5s-185,120.44-185,139.5,87.76,34.5,196,34.5S497.53,418.7,497.53,399.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,503.65a117.38,117.38,0,0,1,0-19.94c1-9.06-1-15.06-3-21.06s-5-13-1-21,5-8,4-12-6-11-4-17,7-9.29,9-14,0-15.59,0-15.59l73-2.41,11,4s0,15,2,21,9,14,9,21-7,20-6,25,2,17,2,29-1,21-1,21-25,16-51,16A77.58,77.58,0,0,1,250,503.65Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 265.9,
    y1: 181.91,
    x2: 295.14,
    y2: 181.91,
    gradientTransform: "translate(-21.34 115.39) rotate(-21.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdbc9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f49a89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 295.98,
    y1: 154.86,
    x2: 302.06,
    y2: 175.53,
    gradientTransform: "translate(-11.59 138.52) rotate(-23.49)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 299.62,
    y1: 273.57,
    x2: 321.92,
    y2: 203.63,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 329.24,
    y1: 155.26,
    x2: 314.54,
    y2: 180.3,
    gradientTransform: "translate(-6.7 189.52) rotate(-28.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa68d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f49a89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 259.53,
    y1: 184.6,
    x2: 293.08,
    y2: 184.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f49a89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f49a89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 302.38,
    y1: 391.51,
    x2: 303.54,
    y2: 452.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c6cff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c6cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 123.93,
    y1: 319.89,
    x2: 136.17,
    y2: 298.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 152.88,
    y1: 310.23,
    x2: 181.08,
    y2: 283.05,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 180.06,
    y1: 318.88,
    x2: 213.08,
    y2: 296.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 41.75,
    y1: 95.51,
    x2: 74.94,
    y2: 38.35,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 120.24,
    y1: 69.32,
    x2: 196.7,
    y2: -4.39,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 193.94,
    y1: 92.77,
    x2: 283.49,
    y2: 30.77,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 262.05,
    y1: 204.97,
    x2: 380.9,
    y2: 204.97,
    gradientTransform: "translate(23.36 442.64) rotate(-71.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f1048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c6cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 379.51,
    y1: 181.84,
    x2: 398.39,
    y2: 181.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c6cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 393.1,
    y1: 164.35,
    x2: 492.92,
    y2: 164.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f1048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8080ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 269.98,
    y1: 176.28,
    x2: 269.18,
    y2: 201.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 289.74,
    y1: 171.16,
    x2: 284.8,
    y2: 200.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 361.84,
    y1: 140.56,
    x2: 344.04,
    y2: 172.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 324.05,
    y1: 143.31,
    x2: 306.24,
    y2: 188.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 321.21,
    cy: 196.15,
    r: 21.35,
    gradientTransform: "translate(-85.95) scale(1.26 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e18388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e18388",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 323.27,
    cy: 183.41,
    r: 21.35,
    gradientTransform: "matrix(0, 1.26, -1, 0, 504.95, -223.93)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 471.35,
    y1: 262.01,
    x2: 492.67,
    y2: 225.3,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 521.76,
    y1: 245.19,
    x2: 570.87,
    y2: 197.85,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 569.1,
    y1: 260.25,
    x2: 626.61,
    y2: 220.43,
    xlinkHref: "#linear-gradient-10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 301.53,
    cy: 399.65,
    rx: 196,
    ry: 34.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 301.53,
    cy: 399.65,
    rx: 196,
    ry: 34.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250,513.65s-1-20.88,0-29.94-1-15.06-3-21.06-5-13-1-21,5-8,4-12-6-11-4-17,7-9.29,9-14,0-15.59,0-15.59l73-2.41,11,4s0,15,2,21,9,14,9,21-7,20-6,25,2,17,2,29-1,31-1,31-25,16-51,16A77.58,77.58,0,0,1,250,513.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280,396.65s-18,13-15,23,11,17,5,24-7,19-3,32,9,32,9,32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M314,399.65s6,17,3,29-12,19-7,32,6.36,22.93,3.18,36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M347,415.65s-33,11-103-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.52,448.13s-6.49-.48-17.49,1.52-38.09,4-55.54,0-41.46-18-41.46-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.52,479.84S290,494.58,245,471.65"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M188,412.93l8.62-2.05a.39.39,0,0,0,0-.76L188,408.06a.39.39,0,0,1-.29-.29l-2.06-8.62a.39.39,0,0,0-.76,0l-2.06,8.62a.41.41,0,0,1-.29.29l-8.62,2.06a.39.39,0,0,0,0,.76l8.62,2.05a.41.41,0,0,1,.29.29l2.06,8.63a.39.39,0,0,0,.76,0l2.06-8.63A.39.39,0,0,1,188,412.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220,400.69l5.23-1.25a.24.24,0,0,0,0-.46L220,397.73a.24.24,0,0,1-.17-.17l-1.25-5.23a.24.24,0,0,0-.46,0l-1.25,5.23a.24.24,0,0,1-.17.17L211.51,399a.23.23,0,0,0,0,.46l5.23,1.25a.24.24,0,0,1,.17.17l1.25,5.23a.23.23,0,0,0,.46,0l1.25-5.23A.24.24,0,0,1,220,400.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M390.75,413.47l9.06-2.17a.41.41,0,0,0,0-.79l-9.06-2.17a.41.41,0,0,1-.31-.3L388.28,399a.41.41,0,0,0-.8,0L385.32,408a.4.4,0,0,1-.3.3L376,410.51a.41.41,0,0,0,0,.79l9.07,2.17a.4.4,0,0,1,.3.3l2.16,9.06a.41.41,0,0,0,.8,0l2.16-9.06A.41.41,0,0,1,390.75,413.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.53,343.65s-5-11.65-1.51-14.58,9.26-9.28,31.89-9.1,40,2.92,43.82,4.55,12.8,4.63,5.8,13.13-44,9.5-45,9.5S260.53,343.65,260.53,343.65Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 300.53,
    cy: 331.65,
    rx: 42.5,
    ry: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M261.53,390.15a66,66,0,0,0,26,12c15,3,54,4,54,4l-3-21-45,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M287.46,177.47s13.85,23.19,20.58,26.94S323.61,190,323.61,190s-15-26.54-17.21-28.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M309.64,158.91s3.64,24.8,12.32,32.6c0,0,12.64.73,23.07-10.92,0,0-11.3-29.85-13.4-34.7C331.63,145.89,303.94,141,309.64,158.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M333.62,365.84c-.18-14-.3-28.83-.23-40,.12-17.63,4-34.87,10.93-49,10.68-21.64-90.21-9.38-85.79,8.33,4,16,11.44,18.07,12.1,29.29.37,6.1-.45,29.51-1.37,51.77C268.3,389.3,333.91,388.91,333.62,365.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M344.32,278.92s15.53-33.64,20.46-48.43,8.87-26.62,5.91-33.52-16.11-17.33-32.21-18-60.47,17.05-65.4,20-3,19.72-1,20.71c0,0-13,20.65-13.81,50.28-.76,26.22,2.24,27.22,24.65,35.06C304.35,312.49,331.75,304.67,344.32,278.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M341,158s-1.27,24.32,3.09,34.3c0,0,7.5,18.63,27.4,7.83,0,0-5.24-41-6-44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M283.43,171.51c2.71,3.4,9.65,23.26,9.65,23.26-3.5,8.74-16.23,9.1-19,8.16S267.8,186,267.8,186c-6.57-1.87-8.27-14.86-8.27-14.86S273.53,159.15,283.43,171.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254,387.65s12,10,43,10,46-10.71,46-10.71l1.5-55.79s-8.82,11.91-34.66,12.2S262,344.81,257,332.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M258,331.65c0,6.62,19,12,42.5,12s42.5-5.38,42.5-12"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 302.53,
    cy: 399.65,
    rx: 196,
    ry: 34.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 119.74,
    y: 326.98,
    width: 57.1,
    height: 9.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 122.46,
    cy: 322.43,
    r: 13.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 152.59,
    cy: 310.51,
    r: 25.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 180.06,
    cy: 318.88,
    r: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 38.71,
    y: 114.74,
    width: 154.83,
    height: 25.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 37.75,
    cy: 102.39,
    r: 37.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 119.46,
    cy: 70.07,
    r: 70.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 193.95,
    cy: 92.76,
    r: 47.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M355.53,213.15s-9-5-28-2-31.1,10.06-42,9.53l-11-.53s12-1,15-1,14.32-4.11,17-5C309.53,213.15,347.53,204.15,355.53,213.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.04,
    y: 142.69,
    width: 18.87,
    height: 124.55,
    rx: 9.44,
    transform: "translate(411.16 -165.59) rotate(71.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 388.95,
    cy: 181.84,
    r: 9.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 443.01,
    cy: 164.35,
    r: 46.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 308.04,
    y: 140.69,
    width: 18.87,
    height: 124.55,
    rx: 9.44,
    transform: "translate(406.56 -163.16) rotate(71.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 384.95,
    cy: 179.84,
    r: 9.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 439.01,
    cy: 162.35,
    r: 46.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M283.53,170.15s-9.5-8.53-22-1-2.27,37.12-2.27,37.12,3.15,10.56,9.77,8.92,8.61-10.56,6.48-16.08,0-11.19-3.4-17.12C272.11,182,288.63,176.33,283.53,170.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M304.37,162.38s-2.68-12.76-19.15-7.57-8.68,41.48-8.68,41.48.7,13,8.76,13,12.84-9.75,11.93-16.69,2.55-15.44.25-23.22C297.48,169.35,308.51,170.92,304.37,162.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M365.83,160s1.88-12.91-15.37-13.71-22.42,36-22.42,36-3.83,12.47,3.76,15.2,15.41-4.74,16.95-11.57,7.7-13.62,8.22-21.71C357,164.2,366.79,169.47,365.83,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M335,153.91s-1.42-15.5-19.29-10.71c-22.18,6-18,45.86-18,45.86s-1.07,13.93,7.5,15,15-8.57,15-16.07,7.86-19.05,6.5-27.63C326.71,160.36,338.21,163.56,335,153.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M300.43,200.51a12.26,12.26,0,0,1,10.28-.66s1.28-13.76-6-13S300.43,200.51,300.43,200.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 318.53,
    cy: 196.15,
    rx: 17,
    ry: 27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 321.53,
    cy: 183.15,
    rx: 27,
    ry: 17,
    transform: "translate(72.54 456.88) rotate(-77.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M289.84,247.26c2.28-7.16,9.86-18.74,15.78-23.67s7.89-7.88,7.89-7.88-3.95-22.68-2-35.5,10.85-23.66,19.72-23.66,8.88,3,8.88,5.91-2,16.76-2,21.69-3,32.23,2,39.78,6.9,29.24-2,47-20.71,21.69-34.51,19.72S282.94,269,289.84,247.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M330.53,177.15c-2,0-5-2-5-7v-5.47s7-1.53,9-1.53h4.15S338.53,177.15,330.53,177.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 464.05,
    y: 274.36,
    width: 99.44,
    height: 16.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 468.78,
    cy: 266.43,
    r: 24.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 521.26,
    cy: 245.67,
    r: 45.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 569.1,
    cy: 260.25,
    r: 30.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M280.59,207.31a12.27,12.27,0,0,1,10-2.39s-1.08-13.77-8.08-11.77S280.59,207.31,280.59,207.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M262.94,213.41a11.26,11.26,0,0,1,9-2.87s-1.91-12.55-8.19-10.25S262.94,213.41,262.94,213.41Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 448.66,
    y1: 142.28,
    x2: 431.6,
    y2: 183.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 430.53,
    y1: 150.62,
    x2: 423.73,
    y2: 166.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 457.09,
    y1: 155.62,
    x2: 447.73,
    y2: 178.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search_empty.ef07d4480c18aec679a7a58989c66444.svg";
export { ForwardRef as ReactComponent };